import React from 'react';
import { formatDate as formatDateGlobal } from '../../../config/appConfig';
import type { MgaPeriod } from '../useData';

type Props = {
  period: Pick<MgaPeriod, 'id' | 'vesselId' | 'vessel' | 'periodFrom' | 'periodTo' | 'currency' | 'status'>;
  title: string;
  eyebrow?: string;
  companyLogoSrc?: string | null;
  companyLogoAlt?: string;
};

/** Shared vessel / period header for non-payslip MGA reports. */
export const ReportHeader: React.FC<Props> = ({
  period,
  title,
  eyebrow = "Master's general account",
  companyLogoSrc = null,
  companyLogoAlt = 'Management company logo',
}) => {
  const ccy = period.currency || 'USD';
  return (
    <header className="mga-report-header">
      <div className="mga-report-header-banner">
        <div className="mga-report-header-side mga-report-header-side-start">
          {companyLogoSrc ? (
            <img src={companyLogoSrc} alt={companyLogoAlt} className="mga-report-logo" />
          ) : null}
        </div>
        <div className="mga-report-header-center">
          <p className="mga-report-eyebrow">{eyebrow}</p>
          <h1>{title}</h1>
          <p className="mga-report-vessel">
            M.V. {period.vessel?.vesselName ?? `#${period.vesselId}`}
            {period.vessel?.vesselAbrv ? ` (${period.vessel.vesselAbrv})` : ''}
          </p>
        </div>
        <div className="mga-report-header-side mga-report-header-side-end" aria-hidden />
      </div>
      <table className="mga-report-header-bar">
        <tbody>
          <tr>
            <td>
              <span className="mga-report-bar-label">Period</span>
              <span className="mga-report-bar-value">
                {formatDateGlobal(period.periodFrom)} – {formatDateGlobal(period.periodTo)}
              </span>
            </td>
            <td>
              <span className="mga-report-bar-label">Currency</span>
              <span className="mga-report-bar-value">{ccy}</span>
            </td>
            <td>
              <span className="mga-report-bar-label">Sheet / status</span>
              <span className="mga-report-bar-value">
                No. {period.id} · {period.status}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </header>
  );
};

export default ReportHeader;
